// frontend/src/App.jsx
import React from 'react';
import ReloadPrompt from './components/ReloadPrompt';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';

import UserAvatar from './components/UserAvatar';
import { TopNavigation } from './components/TopNavigation';
import { BottomNavigation } from './components/BottomNavigation';
import BedManagement from './pages/BedManagement';
import StatusManagement from './pages/StatusManagement';
import PublicDashboard from './pages/PublicDashboard';
import MetricsDashboard from './pages/MetricsDashboard';
import AuditLogs from './pages/AuditLogs';
import ReservationDashboard from './pages/ReservationDashboard'; // [NEW]
import CheckIn from './pages/CheckIn';
import CheckOut from './pages/CheckOut';
import ServiceDashboard from './pages/ServiceDashboard';
import Login from './pages/Login';
import Settings from './pages/Settings'; // [Restaurado]
import OfflineNotification from './components/OfflineNotification';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Global styles for 90vh layout
// Global styles moved to index.css or handled by Tailwind
// Kept for backward compat if needed, but we will use Tailwind classes mostly
const globalStyles = `
  body, html {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    background-color: #f3f4f6; /* bg-gray-100 */
  }
  
  .app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .main-content {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 2rem;
    padding-top: 12rem; /* Increased space for Floating TopNavigation */
    max-width: 100%;
    margin: 0;
    width: 100%;
  }
`;



// Componente de Rota com Permissão
const PermissionRoute = ({ children, permission }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  const hasPermission = user?.role_name === 'Administrador' || user?.permissions?.includes(permission);

  return hasPermission ? children : <Navigate to="/" />;
};

function AppContent() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  return (
    <div className="app">
      <style>{globalStyles}</style>

      {/* Navbar - só mostrar se autenticado */}
      {/* Navbar Replaced by Top Navigation */}
      {/* Navbar - só mostrar se autenticado e não estiver na tela de login */}
      {isAuthenticated && location.pathname !== '/login' && (
        <>
          <TopNavigation />
          <BottomNavigation />
        </>
      )}

      {location.pathname === '/login' ? (
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      ) : (
        <div className="main-content">
          <Routes>
            {/* Rota pública */}
            <Route path="/login" element={<Login />} /> {/* Fallback if needed, but above block handles it */}

            {/* Rota pública - redireciona para modo público do ServiceDashboard */}
            <Route path="/public-dashboard" element={<PublicDashboard />} />

            {/* Rotas protegidas */}
            <Route path="/" element={<PrivateRoute><BedManagement /></PrivateRoute>} />
            <Route path="/beds" element={<PrivateRoute><BedManagement /></PrivateRoute>} />
            <Route path="/status" element={<PrivateRoute><StatusManagement /></PrivateRoute>} />
            <Route path="/checkin" element={<PrivateRoute><CheckIn /></PrivateRoute>} />
            <Route path="/checkout" element={<PrivateRoute><CheckOut /></PrivateRoute>} />
            <Route path="/reservations" element={
              <PrivateRoute>
                <PermissionRoute permission="access_nir">
                  <ReservationDashboard />
                </PermissionRoute>
              </PrivateRoute>
            } />
            <Route path="/metrics" element={<PrivateRoute><MetricsDashboard /></PrivateRoute>} />
            <Route path="/services" element={<PrivateRoute><ServiceDashboard /></PrivateRoute>} />
            <Route path="/audit-logs" element={<PrivateRoute><AuditLogs /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />

            {/* Rota padrão - redirecionar para login se não autenticado */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      )}

      <OfflineNotification />
      <ReloadPrompt />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
